import { Application } from '../../apis/eols-app-link/eols-app-link.constants';
import { AssignmentDto } from '../../apis/eols-assessment-service/eols-assessment-service.dtos';
import { GetAssignmentInfoProps } from '../../models/assignment-types-shared.models';
import { ApplicationNavigateHandlerMapProps, AssignmentTypeStrategy, CoursePlanClickSettings, CoursePlanPerformanceReportClickProps, CoursePlanTitleClickProps } from '../model';
import { navigateExternal, navigateToSimchart, simchartEditClick, simchartPerformanceReportClick } from '../utils/common.utils';

export const simchartChart: AssignmentTypeStrategy = {
  coursePlanTitleClick: (props: CoursePlanTitleClickProps) => {
    const { defArgs, sharedAppLinkParams } = props;
    const { userRole, navigateToApp } = defArgs.props;
    return navigateToSimchart(userRole, navigateToApp, sharedAppLinkParams);
  },
  coursePlanClickSettings: (props: CoursePlanClickSettings) => {
    const { defArgs, sharedAppLinkParams, assignment } = props;
    const { navigateToApp } = defArgs.props;
    simchartEditClick(assignment, navigateToApp, sharedAppLinkParams);
  },
  coursePlanPerformanceReportClick: (props: CoursePlanPerformanceReportClickProps) => {
    const { defArgs, sharedAppLinkParams } = props;
    const { navigateToApp } = defArgs.props;
    simchartPerformanceReportClick(navigateToApp, sharedAppLinkParams);
  },
  assignmentOverviewTitleClick: (props: ApplicationNavigateHandlerMapProps) => navigateExternal(props),
  assignmentOverviewPerformanceReportClick: (props: ApplicationNavigateHandlerMapProps) => navigateExternal(props),
  navigateToAppForAssignmentPerformanceHandlerMap: () => Application.SIMSNG,
  navigateToAppHandlerMap: () => Application.SIMSNG,
  assignmentInfoHandler: (props: GetAssignmentInfoProps): Promise<AssignmentDto> => Promise.resolve(props.newAssignment),
  isScorable: true
};
